import { Component, OnInit, Input, NgZone, ViewChild, ElementRef } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { Chat } from '../../../models/Chat';
import { ChatService } from '../../../services/commons/chat.service';
import { GlobalMethodsService } from '../../../services/global-methods.service';
import { DefaultModalComponent } from '../default-modal/default-modal.component';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { Keyboard } from '@capacitor/keyboard';
import { GlobalVariablesService } from '../../../services/global-variables.service';
@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit {

  public messages: Array<Chat>;
  public newMsg = '';
  @Input('user') user: string;
  @Input('s_ins') s_ins: number;
  @Input('chat_tp') chat_tp: number;
  public setIntID;
  @ViewChild('scroll') scrollElement: any;
  public $platformPause: any;
  public $platformResume: any;
  public installationUserName: string;

  constructor(private modalCtrl: ModalController,
    private chatService: ChatService,
    public gms: GlobalMethodsService,
    public gvs: GlobalVariablesService,
    private defaultModalComponent: DefaultModalComponent,
    private translate: TranslateConfigService,
    private platform: Platform,
    private zone: NgZone) {

    this.$platformPause = this.platform.pause.subscribe(async () => {
      if (this.setIntID) {
        clearInterval(this.setIntID);
      }
    });

    this.$platformResume = this.platform.resume.subscribe(async () => {
      this.setIntID = setInterval(async () => {
        await this.getNewMessages();
      }, 3000);
    });
  }

  async ngOnInit() {
    this.gms.setLoadingTrue();
    this.installationUserName = this.gvs.currentInstallation.user_name;
    this.setIntID = setInterval(async () => {
      await this.getNewMessages();
    }, 3000);
    this.gms.setLoadingFalse();
    // Modal top on keyboard show
    if (this.platform.is('cordova')) {
      Keyboard.addListener('keyboardDidShow', () => {
        this.scrollBottom();
      });

      Keyboard.addListener('keyboardDidHide', () => {
        this.scrollBottom();
      });
    }
  }

  async ionViewWillEnter() {
    this.gms.analyticsTrackEvent('openScreen', { screenName: 'Chat', contentGroup: 'Emergencia' });
    await this.getMessages();
    this.gms.clearCraChatStatusEvent();
    this.gms.clearSupChatStatusEvent();
    if (this.chat_tp === 4) {
      this.gms.changeFooterChatNotif(0);
    } else {
      this.gms.changeHeaderChatNotif(0);
    }
  }

  ngOnDestroy() {
    if (this.setIntID) {
      clearInterval(this.setIntID);
    }
    this.gms.startChatStatusEvent();
  }

  dismiss(value) {
    this.modalCtrl.dismiss({ confirm: value });
  }

  async getMessages() {
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      this.messages = await this.chatService.appGetChat(this.user, this.s_ins, 0, this.chat_tp, 1);
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
    this.scrollBottom();
  }

  async getNewMessages() {
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      let newMessages = await this.chatService.appGetChat(this.user, this.s_ins, 0, this.chat_tp, 0);
      if (newMessages.length > 0) {
        newMessages.forEach(message => {
          this.messages.push(message);
        });
        this.scrollBottom();
      }
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      if (this.setIntID) {
        clearInterval(this.setIntID);
      }
    }
  }

  async sendMessage() {
    if (!this.newMsg) {
      return;
    }
    this.gms.loading();
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {
      let s_chat = 0;
      if (this.chat_tp === 0){
        s_chat = this.gvs.craChatID;
      } else if (this.chat_tp === 4){
        s_chat = this.gvs.supportChatID;
      }
      const response = await this.chatService.cAppChatIns(this.user, this.s_ins, this.chat_tp, this.newMsg, s_chat);
      this.modalCtrl.dismiss(false, '', 'loadSpinner');
      if (!response) {
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.sendMessageKo'),
          'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      }
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
    this.newMsg = '';
  }

  scrollBottom() {
    setTimeout(() => {
      this.zone.run(() => {
        this.scrollElement.nativeElement.scrollTop = this.scrollElement.nativeElement.scrollHeight;
      });
    }, 200);
  }
}
